module.exports = __webpack_public_path__ + "img/NotifyError.b5ae464d.svg";